import { Action, createReducer, on } from '@ngrx/store';
import * as OrganizationActions from '../actions/organization.actions';
import { IArea } from '@app/models/area.interface';
import { IProduct } from '@app/models/product.interface';
import { ILocation } from '@app/models/location.interface';

export const organizationFeatureKey = 'organization';

export interface State {
  categories: any,
  areas: IArea[],
  currentItem: any,
  section: number,
  isLoading: boolean,
  query: string,

  /* Start Multilocations */
  locations: ILocation[],
  me: ILocation,
  currentPage: number,
  total: number,
  sortType: string
  direction: string,
  pageSize: number,
  error_message: string,
  /* End Multilocations */

  /**
   * Master Sorter
   */

  inCat: IProduct[],
  inCatCopy: IProduct[],
  notInCat: any,
  notInCatCopy: any,
  uncategorized: any,
  uncategorizedCopy: any,
  notInCatPos : string
  inCatPos : string
  
}

export const initialState: State = {
  categories: null,
  areas: null,
  currentItem: null,
  section: 0,
  inCat: [],
  notInCat: [],
  inCatCopy: [],
  notInCatCopy: [],
  isLoading: true,
  query: null,
  uncategorized: [],
  uncategorizedCopy: [],
  notInCatPos: null,
  inCatPos: null,
  /* Start Multilocations */
  locations: [],
  me: null,
  total: 0,
  currentPage: 0,
  sortType: 'locName',
  direction: 'DESC',
  pageSize: 100,
  error_message: ''
  /* End Multilocations */
};

export const reducer = createReducer(
  initialState,

  on(OrganizationActions.loadCategories, state => state),
  on(OrganizationActions.loadCategoriesSuccess, (state, action) => ({
    ...state,
    categories: action.categories
  })),
  on(OrganizationActions.loadCategoriesFailure, (state, action) => state),
  on(OrganizationActions.loadAreas, state => state),
  on(OrganizationActions.loadAreasSuccess, (state, action) => ({
    ...state,
    areas: action.areas
  })),
  on(OrganizationActions.loadAreasFailure, (state, action) => state),
  on(OrganizationActions.saveCategory, state => state),
  on(OrganizationActions.saveCategorySuccess, (state, action) => ({
    ...state,
    categories: [...state.categories, action.category]
  })),
  on(OrganizationActions.saveCategoryFailure, (state, action) => state),
  on(OrganizationActions.updateCategory, state => state),
  on(OrganizationActions.updateCategorySuccess, (state, { prdCatID, category }) => ({
    ...state,
    categories: state.categories.map(item => {

      if (item.prdCatID == prdCatID) {
        return category
      }
      return item;
    })
  })),
  on(OrganizationActions.updateCategoryFailure, (state, action) => state),
  on(OrganizationActions.deleteCategory, state => state),
  on(OrganizationActions.deleteCategorySuccess, (state, action) => ({
    ...state,
    categories: state.categories.filter(item => item.prdCatID != action.category.prdCatID)
  })),
  on(OrganizationActions.deleteArea, state => state),
  on(OrganizationActions.deleteAreaSuccess, (state, action) => ({
    ...state,
    areas: state.areas.filter(item => item.prdAreaID != action.prdAreaID)
  })),
  on(OrganizationActions.addArea, state => state),
  on(OrganizationActions.addAreaSuccess, (state, action) => {
    return {
      ...state,
      areas: [...state.areas, action.area],
    };
  }),
  on(OrganizationActions.updateArea, state => state),
  on(OrganizationActions.updateAreaSuccess, (state, { area }) => ({
    ...state,
    areas: state.areas.map(item => {

      if (item.prdAreaID == area.prdAreaID) {
        return area
      }

      return item;

    })  
  })),
  on(OrganizationActions.setCurrentItem, (state, action) => ({
    ...state,
    currentItem: action.item
  })),
  on(OrganizationActions.loadAllSettingsSuccess, (state, {
    categories,
    areas
  }) => ({
    ...state,
    categories,
    areas
  })),
  on(OrganizationActions.checkArea, (state, {
    prdAreaID,
    checked
  }) => ({
    ...state,
    areas: state.areas ? state.areas.map((item) => {

      if (item.prdAreaID == prdAreaID) {
        item.checked = checked;
      }
      return item;
    }) : []
  })),
  on(OrganizationActions.setPsa, (state, action) => ({
    ...state,
    areas: state.areas ? state.areas.map(item => {
      if (action.psa.includes(item.prdAreaID)) {
        item.checked = true;
      }
      return item;
    }) : []
  })),
  on(OrganizationActions.resetPsa, (state, action) => ({
    ...state,
    areas: state.areas ? state.areas.map(item => {
      item.checked = false;
      return item;
    }) : []
  })),
  on(OrganizationActions.setSection, (state, action) => ({
    ...state,
    section: action.section
  })),
  on(OrganizationActions.loadMasterSortCategories, (state) => ({
    ...state,
    isLoading: true
  })),
  on(OrganizationActions.loadMasterSortCategoriesSuccess, (state, action) => ({
    ...state,
    inCat: action.data.inCat,
    inCatCopy: JSON.parse(JSON.stringify(action.data.inCat)),
    notInCat: action.data.notInCat,
    notInCatCopy: JSON.parse(JSON.stringify(action.data.notInCat)),
    isLoading: false
  })),
  on(OrganizationActions.removeFromMasterSortCategoriesSuccess, (state, { product }) => ({
    ...state,
    inCat: state.inCat.filter(item => item.prdID != product.prdID),
    notInCat: [...state.notInCat, product],
    notInCatCopy: [...state.notInCatCopy, product],
    categories: state.categories.map(item => {

      if (state.currentItem.prdCatID == item.prdCatID) {
        item.count -= 1
      }

      return item
    })
  })),
  on(OrganizationActions.addFromMasterSortCategoriesSuccess, (state, { product }) => ({
    ...state,
    inCat: [product, ...state.inCat],
    notInCat: state.notInCat.filter(item => item.prdID != product.prdID),
    notInCatCopy: state.notInCatCopy.filter(item => item.prdID != product.prdID),
    categories: state.categories.map(item => {

      if (state.currentItem.prdCatID == item.prdCatID) {
        item.count += 1
      }

      return item
    })
  })),
  on(OrganizationActions.loadMasterSortAreas, (state) => ({
    ...state,
    isLoading: true
  })),
  on(OrganizationActions.loadMasterSortAreasSuccess, (state, action) => ({
    ...state,
    inCat: action.data.inCat,
    inCatCopy: JSON.parse(JSON.stringify(action.data.inCat)),
    notInCat: action.data.notInCat,
    notInCatCopy: JSON.parse(JSON.stringify(action.data.notInCat)),
    isLoading: false,
    uncategorized: action.data.uncategorized,
    uncategorizedCopy: JSON.parse(JSON.stringify(action.data.uncategorized))
  })),
  on(OrganizationActions.removeFromMasterSortAreasSuccess, (state, { product }) => ({
    ...state,
    inCat: state.inCat.filter(item => item.prdID != product.prdID),
    inCatCopy: state.inCatCopy.filter(item => item.prdID != product.prdID),
    notInCat: state.notInCat.map(item => {
      if (item.prdCatID == product.prdCatID) {
        item.products.push(product);
      }
      return item;
    }),
    areas: state.areas.map(item => {
      if (state.currentItem.prdAreaID == item.prdAreaID) {
        item.count -= 1
      }
      return item
    }),
    uncategorized: product.prdCatID == null ? [product, ...state.uncategorized] : state.uncategorized,
    uncategorizedCopy: product.prdCatID == null ? [product, ...state.uncategorizedCopy] : state.uncategorizedCopy

  })),
  on(OrganizationActions.addFromMasterSortAreasSuccess, (state, { product }) => ({
    ...state,
    inCat: [product, ...state.inCat],
    notInCat: state.notInCat.map(a => {
      a.products = a.products.filter(b => {
        if (b.prdID != product.prdID) return b;
      })
      return a;
    }),
    areas: state.areas.map(item => {
      if (state.currentItem.prdAreaID == item.prdAreaID) {
        item.count += 1
      }

      return item
    }),
    uncategorized: state.uncategorized.filter(item => item.prdID != product.prdID),
    uncategorizedCopy: state.uncategorizedCopy.filter(item => item.prdID != product.prdID)
  })),
  on(OrganizationActions.addAllFromMasterSortAreasSuccess, (state, { products, prdCatID }) => ({
    ...state,
    inCat: products.concat(state.inCat),
    notInCat: state.notInCat.map(item => {
      if (item.prdCatID == prdCatID) {
        item.products = [];
      }
      return item;
    }),
    areas: state.areas.map(item => {
      if (state.currentItem.prdAreaID == item.prdAreaID) {
        item.count += products.length;
      }
      return item
    }),
  })),
  on(OrganizationActions.addUncategorizedFromMasterSortAreasSuccess, (state, { products }) => ({
    ...state,
    areas: state.areas.map(item => {
      if (state.currentItem.prdAreaID == item.prdAreaID) {
        item.count += products.length
      }
      return item
    }),
    inCat: state.inCat.concat(products),
    uncategorized: []
  })),

  on(OrganizationActions.setQueryNotInArea, (state, { query }) => ({
    ...state,
    query: query,
    notInCatCopy: JSON.parse(JSON.stringify(state.notInCatCopy)),
    notInCat: state.notInCatCopy.filter((item, i) => {
      const isMatch = item.products.find(item => item.prdNameEn.toLowerCase().includes(query) || item.prdCode.toLowerCase().includes(query));
      if(isMatch){
        if (localStorage.getItem('trakrCounting-prdCodes')) {
          const columns = localStorage.getItem('trakrCounting-prdCodes').split('').map(item => parseInt(item));
          if (columns.includes(3)) {
            item.products = item.products.filter(inner => inner.prdCode.toLowerCase().includes(query));
            return item;
          }
        }
        item.products = item.products.filter(inner => inner.prdNameEn.toLowerCase().includes(query));
        return item;
      }
    }),
    uncategorized: state.uncategorizedCopy.filter(item => {
      if(item.prdNameEn.toLowerCase().includes(query.toLowerCase())){
        return item;
      }
    })
  })),
  on(OrganizationActions.setQueryNotInCategory, (state, { query }) => ({
    ...state,
    query: query,
    notInCat: state.notInCatCopy.filter(item => {
      if (localStorage.getItem('trakrCounting-prdCodes')) {
        const columns = localStorage.getItem('trakrCounting-prdCodes').split('').map(item => parseInt(item));
        if (columns.includes(3)) {
          return item.prdCode.toLowerCase().includes(query)
        }
      }

      return item.prdNameEn.toLowerCase().includes(query)
    })
  })),
  on(OrganizationActions.resetQueryNotIn, (state) => ({
    ...state,
    notInCat: state.notInCatCopy,
    uncategorized: state.uncategorizedCopy
  })),
  on(OrganizationActions.resetQueryIn, (state) => ({
    ...state,
    inCat: state.inCatCopy
  })),
  on(OrganizationActions.setQueryIn, (state, { query }) => ({
    ...state,
    inCat: state.inCatCopy.filter(item => {

      if (localStorage.getItem('trakrCounting-prdCodes')) {
        const columns = localStorage.getItem('trakrCounting-prdCodes').split('').map(item => parseInt(item));
        if (columns.includes(2)) {
          return item.prdCode.toLowerCase().includes(query)
        }
      }

      return item.prdNameEn.toLowerCase().includes(query)

    })
  })),
  on(OrganizationActions.setNoInCatPos, (state, action) => ({
    ...state,
    notInCatPos: action.posName
  })),
  on(OrganizationActions.setInCatPos, (state, action) => ({
    ...state,
    inCatPos: action.posName
  })),
  on(OrganizationActions.sortCategoryByNameSuccess, (state, action) => ({
    ...state,
    inCat: quickSort(state.inCat)
  })),
  on(OrganizationActions.sortAreaByNameSuccess, (state, action) => ({
    ...state,
    inCat: quickSort(state.inCat)
  })),
  on(OrganizationActions.addToCount, (state, { pcmItemQty, product, prdCatID }) => ({
    ...state,
    categories: state.categories.map((item) => {
      if(item.prdCatID == prdCatID){
        item.count += 1;
      }

      for(let p of item.products){
        if(p.prdID == product.prdID){
          p.count += pcmItemQty;
        }
      }

      return item;
    })
  })),

  /* start multilocations reducers */
  on(OrganizationActions.loadLocationsSuccess, (state, action) => ({
    ...state,
    locations: action.locations,
    total: action.total
  })),
  on(OrganizationActions.loadLocationsFailure, (state, action) => state), 
  on(OrganizationActions.loadLocations, state => ({
    ...state,
    isLoading: true
  })),
  on(OrganizationActions.sortLocations, (state, action) => ({
    ...state,
  })),
  on(OrganizationActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(OrganizationActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(OrganizationActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(OrganizationActions.saveLocationSuccess, (state, { location }) => ({
    ...state,
    locations: [location, ...state.locations]
  })),
  on(OrganizationActions.deleteLocation, state => state),
  on(OrganizationActions.deleteLocationSuccess, (state, action) => ({
    ...state,
    locations: state.locations.filter(x => x.locID != action.id)
  })),
  on(OrganizationActions.noDeleteLocationSuccess, (state, action) => ({
    ...state,
  })),
  on(OrganizationActions.loadLocation, state => state),
  on(OrganizationActions.loadLocationSuccess, (state, action) => ({
    ...state,
    location: action.location
  })),
  on(OrganizationActions.loadLocationFailure, (state, action) => state),
  on(OrganizationActions.updateLocationSuccess, (state, { location }) => ({
    ...state,
    locations: state.locations.map((item)=> {
      if(item.locID == location.locID){
        return location
      }else{
        return item
      }
    }),
  })),
  on(OrganizationActions.resetLocation, (state, action) => ({ 
    ...state,
    location: null
  })),
  /* end multilocations reducers */
);

function quickSort(array){
  if (array.length <= 1) {
    return array;
  }

  var pivot = array[0];
  
  var left = []; 
  var right = [];

  for (var i = 1; i < array.length; i++) {
    array[i].prdNameEn.toLowerCase() < pivot.prdNameEn.toLowerCase() ? left.push(array[i]) : right.push(array[i]);
  }

  return quickSort(left).concat(pivot, quickSort(right));

}